// RIGHT-TO-LEFT MARK：历史方案曾用它在展示层打断 LTR 连续段做逐词反序，
// 现已改为“所见即所存”，不再插入该标记。这里保留剥离函数，用于清理旧数据里可能残留的标记。
const RTL_MARK = '\u200f';

export const stripRtlWordMarks = value => (typeof value === 'string' ? value.split(RTL_MARK).join('') : value);

// 反转单词顺序但保留空白符的原始位置（空白不参与反转）。
// 它是严格自反的：reverse(reverse(x)) === x，因此在“逻辑序 ↔ 阿语展示序”之间可无损互转：
// 表单里按逻辑序（输入顺序）编辑，提交时转成展示序入库，编辑页加载时再转回逻辑序。
export const reverseWordsKeepWhitespace = value => {
  if (typeof value !== 'string') return value;
  const words = value.match(/\S+/g);
  if (!words) return value;
  const blanks = value.split(/\S+/);
  const reversed = [...words].reverse();
  let result = blanks[0] || '';
  for (let i = 0; i < reversed.length; i += 1) {
    result += reversed[i] + (blanks[i + 1] || '');
  }
  return result;
};

// reverseWordsKeepWhitespace 的按行版本（不跨换行，多行文本逐行独立转换）。
export const reverseWordsKeepWhitespaceByLines = value =>
  typeof value === 'string'
    ? value
        .split('\n')
        .map(line => reverseWordsKeepWhitespace(line))
        .join('\n')
    : value;
